const fetchData = (widget) => {
    return fetch(`/api/v1/widgets/${widget}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json'
        }
    }).then(res => {
        if (!res.ok) {
            const error = new Error(res.statusText);
            error.json = res.json();
            throw error;
        }

        return res.json();
    });
}

export { fetchData };
